// Silently fails on the server
export function setCssVariable(name: string, value: string) {
  if (import.meta.client) {
    window.document.documentElement.style.setProperty(
      name.startsWith('--') ? name : `--${name}`,
      value,
    )
  }
}
